import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { fontWeight } from 'src/assets/fonts-config';

export const Title = styled('div', { label: 'Title' })`
    font-size: 14px;
    font-weight: ${fontWeight.bold};
    color: ${mainColors.main.primary};
`;

export const Image = styled('img', { label: 'Image' })`
    display: block;
    width: 100%;
    margin-bottom: 12px;
`;
